import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Typography } from '@one-thd/sui-atomic-components';
import { UsedFilterPanel } from './UsedFilterPanel';

export function UsedFilterSidebar({
  categories,
  keyword,
  onKeywordChange,
  onToggleCategory,
  onDimensionsChange,
  appliedDimensions,
  onClearAllRefinements,
  stores,
  selectedStoreIds,
  onToggleStore,
  resultCount,
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <div className="sui-hidden md:sui-block">
        <aside className="used-filter-sidebar sui-flex sui-flex-col sui-gap-4">
          <UsedFilterPanel
            categories={categories}
            keyword={keyword}
            onKeywordChange={onKeywordChange}
            onToggleCategory={onToggleCategory}
            onDimensionsChange={onDimensionsChange}
            appliedDimensions={appliedDimensions}
            onClearAllRefinements={onClearAllRefinements}
            stores={stores}
            selectedStoreIds={selectedStoreIds}
            onToggleStore={onToggleStore}
          />
        </aside>
      </div>

      <div className="md:sui-hidden">
        <Button
          variant="secondary"
          fullWidth
          onClick={() => setIsDrawerOpen(true)}
        >
          Sort & Filter
        </Button>
        <Modal open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} size="md">
          <div className="sui-flex sui-flex-col sui-gap-4 sui-p-4">
            <div className="sui-flex sui-items-center sui-justify-between">
              <Typography variant="body-lg" weight="bold">Sort & Filter</Typography>
              <Button variant="ghost" size="sm" onClick={() => setIsDrawerOpen(false)}>
                Close
              </Button>
            </div>

            <UsedFilterPanel
              categories={categories}
              keyword={keyword}
              onKeywordChange={onKeywordChange}
              onToggleCategory={onToggleCategory}
              onDimensionsChange={onDimensionsChange}
              appliedDimensions={appliedDimensions}
              onClearAllRefinements={onClearAllRefinements}
              stores={stores}
              selectedStoreIds={selectedStoreIds}
              onToggleStore={onToggleStore}
            />

            <div className="sui-pt-2 sui-border-t sui-border-primary">
              <Button variant="primary" fullWidth onClick={() => setIsDrawerOpen(false)}>
                View Results ({resultCount})
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

UsedFilterSidebar.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      count: PropTypes.number,
      selected: PropTypes.bool,
    })
  ).isRequired,
  keyword: PropTypes.string.isRequired,
  onKeywordChange: PropTypes.func.isRequired,
  onToggleCategory: PropTypes.func.isRequired,
  onDimensionsChange: PropTypes.func,
  appliedDimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      refinements: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          refinementKey: PropTypes.string,
        })
      ),
    })
  ),
  onClearAllRefinements: PropTypes.func,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.string,
      name: PropTypes.string,
      distance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      count: PropTypes.number,
    })
  ).isRequired,
  selectedStoreIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleStore: PropTypes.func.isRequired,
  resultCount: PropTypes.number,
};

UsedFilterSidebar.defaultProps = {
  onDimensionsChange: null,
  appliedDimensions: [],
  onClearAllRefinements: null,
  resultCount: 0,
};
